<template>
  <!-- checkbox组件，用于关联勾选功能,关联的key是number，用于区分el-checkbox的boolean -->
  <div class="yq-checkbox">
    <el-checkbox v-model="value">
      <slot></slot>
    </el-checkbox>
  </div>
</template>

<script>


import {watch} from "vue";

export default {
  props: {
    modelValue: {
      type: Number,
      default: false
    },
    activeValue: {
      type: Number,
      default: 1
    },
    inactiveValue: {
      type: Number,
      default: 0
    }
  },

  name: "",
  components: {
  },
  data() {
    return {
      value: false,
    };
  },
  created() {
    this.init();
    watch(() => this.modelValue, () => {
      this.init();
    })
  },
  methods: {
    init() {
      this.value = this.modelValue === this.activeValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.yq-checkbox{
  display: inline-flex;
  margin-right: 10px;
  &:last-child{
    margin-right: 0;
  }
}
</style>